export default __webpack_public_path__ + "static/media/favicon1.ea13bd97.png";